'use client';

import React from 'react';
import { css, cx } from 'styled-system/css';

import Tooltip from '@shaojiang/components/Tooltip';

interface Props {
  url: string;
  children: React.ReactNode;
  className?: string;
  tooltip?: string;
}

/**
 * Opens a link in a new window through onClick. Used when this is a child of another link.
 * It still renders an <a>, so middle-click opens the link in a new tab.
 */
export default function ShaojiangWindowOpenLink({ url, children, className, tooltip = '' }: Props) {
  const goToExternalLink = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (!url) {
    return children;
  }

  const link = (
    <a href={url} className={cx(css({ cursor: 'pointer' }), className)} onClick={goToExternalLink}>
      {children}
    </a>
  );

  return tooltip ? <Tooltip title={tooltip}>{link}</Tooltip> : link;
}
